import http from '../../utils/fetch';

export default {
    baseurl: '/api/swyl/v1/xuqiu',
//查询用户信息
    custagentPage(query){
        return http({
            url:'/api/select/custagent/selectPage',
            method: 'post',
            params: query
        });
    },
    //查询用户信息
    customerOption(query){
        return http({
            url:'/api/swyl/v1/yonghu/bscCustomer/showCustDetail',
            method: 'post',
            data: query
        });
    },
    //查询用户信息经销商客户信息
    agentOption(query){
        return http({
            url: '/api/swyl/v1/yonghu/bscCustomer/selectAgentList',
            method: 'post',
            data: query
        });
    },

    //客户全称
    selectEuName() {
        return http({
            url: this.baseurl + '/userResProduct/selectEuName',
            method: 'post'
        });
    },
    //需求列表分页/检索
    selectPage(query) {
        return http({
            url: this.baseurl + '/userResProcurement/selectPage',
            method: 'post',
            params: query
        });
    },
    //资源需求列表分页/检索
    showZYXQPage(query) {
        return http({
            url: '/api/swyl/v1/xuqiu/userResDemandDept/showZYXQPage',
            method: 'post',
            params: query
        });
    },
    //需求详情-采购需求
    demandDetail1(v) {
        return http.post('/api/swyl/v1/xuqiu/userResProcurement/selectById?id='+v);
    },
    //需求详情-订单需求
    demandDetail2(v) {
        return http.post('/api/swyl/v1/xuqiu/userResProduct/selectById?id='+v);
    },
    //需求详情-资源需求
    demandDetail3(v) {
        return http.post('/api/swyl/v1/xuqiu/userResDemand/selectById?id='+v);
    },
    //删除所选？
    deletechecked(ids) {
        return http({
            url: this.baseurl + '/userResProduct/deleteByIds',
            method: 'post',
            data: ids
        });
    },
    //需求列表页需求统计图表
    demandChart(query) {
        return http({
            url: this.baseurl + '/userResProduct/chartPer',
            method: 'post',
            params: query
        });
    },
    //资源需求列表页需求统计图表
    resourceChart(query) {
        return http({
            url: this.baseurl + '/userResDemandDept/chartPer',
            method: 'post',
            params: query
        });
    },
    //用户名
    showCustDetail(){
        return http({
            url: '/api/swyl/v1/yonghu/bscCustomer/showCustDetail',
            method: 'post',
        });
    },
    //产品大类列表
    showLevelName() {
        return http.post('/api/swyl/v1/productlevel/productLevel/getAllId');
    },
    //产品型号下拉列表
    showproModel(v){
        return http.post('/api/swyl/v1/productlevel/productLevel/getAllIds?id='+v);
    },
    showAllproModel(){
        return http({
            url: '/api/swyl/v1/productlevel/productLevel/getAllModel',
            method: 'post',
        });
    },
    //采购需求暂存
    zanCun1(cai) {
        return http({
            url: this.baseurl + '/userResProcurement/zanCun',
            method: 'post',
            data: cai
        });
    },
    //订单需求暂存
    zanCun2(cai) {
        return http({
            url: this.baseurl + '/userResProduct/zanCun',
            method: 'post',
            data: cai
        });
    },
    //采购需求提交
    refer(cai) {
        return http({
            url: this.baseurl + '/userResProcurement/refer',
            method: 'post',
            data: cai
        });
    },
    //采购需求列表
    showprocuer(query) {
        return http({
            url: this.baseurl + '/userResProcurement/selectById',
            method: 'post',
            params: query
        });
    },
    //通过用户名带出联系人
    selectByEntity(query) {
        return http({
            url: '/api/swyl/v1/yonghu/bscCustomer/selectByEntity',
            method: 'post',
            params: query
        });
    },
    //新增订单需求
    savedd(query) {
        return http({
            url: this.baseurl + '/userResProduct/insert',
            method: 'post',
            data: query
        });
    },
    //新增资源需求
    savezy(query) {
        return http({
            url: this.baseurl + '/userResDemand/insert',
            method: 'post',
            data: query
        });
    },
    //资源需求闭环详情展示
    showzyDetail(v,m) {
        return http.post('/api/swyl/v1/xuqiu/userResDemandDept/showzyDetail?id='+v+'&instid='+m);
    },
    //资源需求闭环
    bihuan(query) {
        return http({
            url: this.baseurl + '/userResDemandDept/updateYes',
            method: 'post',
            data: query
        });
    },
    //回复
    huifu(query) {
        return http({
            url: this.baseurl + '/userResDemandDept/huifu',
            method: 'post',
            data: query
        });
    },
    //部门省略列表信息
    showdeptDetail(query) {
        return http({
            url: this.baseurl + '/userResDemandDept/showdeptDetail',
            method: 'post',
            params: query
        });
    },
    //保存需求详情
    saveDetail(f) {
        return http({
            url: this.baseurl + '/userResProduct/insert',
            method: 'post',
            data:f
        })
    },
    //交互转化需求获取交互信息
    showUserCare(v){
        return http.post('/api/swyl/v1/guanhuai/userCareExecution/selectAllById?id='+v);
    },
    showChannel(){
        return http({
            url: this.baseurl + '/userResProcurement/showChannel',
            method: 'post',
        })
    },
    showGYS(value){
        return http({
            url: '/api/swyl/v1/test/bscUserInfoSupplierCopy/showGYS',
            method: 'post',
            params:value
        })
    },
    showGYSSh(value){
        return http({
            url: '/api/swyl/v1/test/bscUserInfoSupplierCopy/showGYSSh',
            method: 'post',
            params:value
        })
    },
    /*新的资源需求*/
    //链群
    selectJobGroup(){
        return http({
            url: '/api/swyl/v1/xuqiu/userResDemandJob/selectJobGroup',
            method: 'post'
        })
    },
    //回复人列表
    selectUser(value){
        return http({
            url: '/api/swyl/v1/xuqiu/userResDemandJob/selectUser',
            method: 'post',
            params:value
        });
    },
    //经销商信息带出
    getByCode(value){
        return http({
            url: '/api/swyl/v1/xuqiu/userResDemandDept/getByCode',
            method: 'post',
            params:value
        });
    },
    //节点下拉列表
    selectJobPoint(value){
        return http.post('/api/swyl/v1/xuqiu/userResDemandJob/selectJobPoint?jobGroup='+value);
    },
    //需求详情-资源需求
    resourceDetail(v) {
        return http.post('/api/swyl/v1/xuqiu/userResDemandDept/resourceDetail?id='+v);
    },
    //需求详情-资源需求闭环
    showzyBH(v) {
        return http.post('/api/swyl/v1/xuqiu/userResDemandDept/showzyBH?id='+v);
    },
    //资源需求右下角链群列表
    lianDataPage(v){
        return http({
            url: '/api/swyl/v1/xuqiu/userResDemandDept/lianDataPage',
            method: 'post',
            params: v
        });
    },
    //资源需求右下角链群列表
    jobUserPage(v){
        return http({
            url: '/api/swyl/v1/xuqiu/userResDemandJob/jobUserPage',
            method: 'post',
            params: v
        });
    },
    //资源需求右下角链群列表
    insertJob(v){
        return http({
            url: '/api/swyl/v1/xuqiu/userResDemandJob/insert',
            method: 'post',
            params: v
        });
    },
    selectJob(value){
        return http.post('/api/swyl/v1/xuqiu/userResDemandJob/selectById?id='+value);
    },
    deleteJob(value){
        return http.post('/api/swyl/v1/xuqiu/userResDemandJob/deleteJob?id='+value);
    },
    //////////////////////////////////////1+N体系//////////////////////////////////////////////////
    //I+N体系提报
    insertEva(v){
        return http({
            url: '/api/swyl/v1/xuqiu/userResEva/insert',
            method: 'post',
            data: v
        });
    },
    //1+N体系分页
    selectEvaPage(v){
        return http({
            url: '/api/swyl/v1/xuqiu/userResEva/selectEvaPage',
            method: 'post',
            params: v
        });
    },
    getContent(v){
        return http.post('/api/swyl/v1/xuqiu/userResEva/selectById?id='+v);
    },
    cai(v,m){
        return http.post('/api/swyl/v1/xuqiu/userResEvaAssess/cai?reId='+v+'&sort='+m);
    },
    zan(v,m){
        return http.post('/api/swyl/v1/xuqiu/userResEvaAssess/zan?reId='+v+'&sort='+m);
    },
    doRep(v){
        return http({
            url: '/api/swyl/v1/xuqiu/userResEvaRep/doRep',
            method: 'post',
            params: v
        });
    },
    getUser(){
        return http({
            url: '/api/swyl/v1/xuqiu/userResEva/getUser',
            method: 'post'
        });
    },
    zhiding(v){
            return http.post('/api/swyl/v1/xuqiu/userResEva/zhiding?id='+v);
    },
    biaoxing(v){
            return http.post('/api/swyl/v1/xuqiu/userResEva/biaoxing?id='+v);
    },
    repContentPage(v){
        return http({
            url: '/api/swyl/v1/xuqiu/userResEvaRep/repContentPage',
            method: 'post',
            params: v
        });
    },
    deleteRep(v){
        return http.post('/api/swyl/v1/xuqiu/userResEvaRep/deleteRep?id='+v);
    },
    showcgproduct(v){
        return http.post('/api/swyl/v1/demo/userResPurchaseProduct/showcgproduct?urpid='+v);
    }
}
